import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";
import ConciergeWidget from "@/components/ConciergeWidget";

export default function Layout() {
    return (
        <>
            <Header />
            <main className="min-h-[60vh]">
                <Outlet />
            </main>
            <Footer />
            <FloatingCTAs />
            <ConciergeWidget />
        </>
    );
}
